import React from "react";
import Styles from './styles.module.scss';
import {useTranslation} from "react-i18next";


const HiwS1 = () => {
    const { t } = useTranslation();
    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.elementWidthWP}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Эволюция: ценность без пустых обещаний')}</div>
                <div className={`${Styles.contentWrapSubTitle}`}>{t('Мы создаем криптовалюту для людей')}!</div>
                <div className={`${Styles.contentWrapNote}`}>
                    {t('Мы не делаем “пузыри”, мы создаем криптовалюты, которые решают проблемы рынка и обеспечивают реальную ценность. Мы верим в технологии, которые работают, а не в краткосрочную шумиху')}.
                </div>
                <div className={`${Styles.ftfBackgroundBtn}`}>{t('Станьте частью перемен')}!</div>
            </div>
        </section>
    );
};

export default HiwS1;
